/** Ключ session/localStorage: id платежа (БД) перед редиректом на оплату */
export const PENDING_PAYMENT_STORAGE_KEY = "virtuoz_pending_payment_id";
/** Ключ маркера «уже отправили ecommerce + цель за этот платёж» */
export const ecommerceSentKey = (paymentDbId) => `virtuoz_ecommerce_sent_${paymentDbId}`;
/**
 * Уже отправляли покупку (цель + ecommerce) за этот платёж?
 *
 * Смотрим ОБА хранилища. sessionStorage — быстрый маркер этой вкладки;
 * localStorage — общий для всех вкладок одного origin, и он тут обязателен:
 * возврат с кассы приходит в ОТДЕЛЬНУЮ вкладку `/payment/success`, которая
 * рассылает сигнал об успехе во ВСЕ остальные вкладки приложения (см.
 * paymentReturn). Без общего маркера каждая открытая вкладка отправила бы
 * покупку ещё раз, и выручка в Метрике задвоилась бы — своей дедупликации
 * между загрузками страницы у Метрики нет.
 */
export function hasAlreadySentEcommerceForPayment(paymentDbId) {
    const key = ecommerceSentKey(paymentDbId);
    try {
        if (localStorage.getItem(key) === "1") {
            return true;
        }
    }
    catch {
        /* private mode / quota — проверим хотя бы sessionStorage */
    }
    try {
        return sessionStorage.getItem(key) === "1";
    }
    catch {
        return false;
    }
}
/** Пометить платёж как отправленный — в оба хранилища (см. проверку выше). */
export function markEcommerceSentForPayment(paymentDbId) {
    const key = ecommerceSentKey(paymentDbId);
    try {
        localStorage.setItem(key, "1");
    }
    catch {
        /* ignore */
    }
    try {
        sessionStorage.setItem(key, "1");
    }
    catch {
        /* ignore */
    }
}
/**
 * Занять право на отправку покупки: true — отправляем мы, false — уже
 * отправлено кем-то (другой вкладкой или этой же на прошлом рендере).
 *
 * Проверка и пометка — одним вызовом и синхронно, чтобы между ними не
 * вклинилась вторая вкладка: сигнал об оплате прилетает во все вкладки
 * одновременно.
 */
export function claimEcommerceSendForPayment(paymentDbId) {
    if (hasAlreadySentEcommerceForPayment(paymentDbId)) {
        return false;
    }
    markEcommerceSentForPayment(paymentDbId);
    return true;
}
